const TO_DETAIL = {
  name: 'terminalDetails',
  params: {
    id: 'serial_number'
  }
}

const STATUS = {
  id: 'status',
  label: 'status',
  type: 'status',
  transform: 'status'
}
const SERIAL_NUMBER = {
  id: 'serial_number',
  label: 'serial_number',
  type: isLink => (isLink ? 'link' : 'text'),
  link: {
    to: TO_DETAIL.name,
    params: TO_DETAIL.params
  }
}

const CREATED_AT = {
  id: 'created_at',
  label: 'request-date',
  type: 'date',
  format: 'date'
}

const TERMINAL_LIST_FIELDS = [STATUS, SERIAL_NUMBER]

export { TERMINAL_LIST_FIELDS, TO_DETAIL, CREATED_AT }
